import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { getOpportunityListTableQueryKeys } from "../query/queryKeyFactory";

type OpportunityListType = {
    opportunityListId: string;
};

const useInvalidateOpportunityQueries = () => {
    const queryClient = useQueryClient();

    return useCallback(
        (listId?: OpportunityListType["opportunityListId"]): Promise<void[]> =>
            Promise.all(
                getOpportunityListTableQueryKeys(listId).map((queryKey) => queryClient.invalidateQueries({ queryKey })),
            ),
        [queryClient],
    );
};

export default useInvalidateOpportunityQueries;
